import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchedSubSellers: [],
  loading: false,
  selectedStatus: 0,
  selectedSubSellerID: "",
  statuses: {},
  rejectReason: {},
  profileStatuses: {},
  profileDetail:{},
  gdsAggregator: {},
  currentStatus: "ALL",
  isInput: false,
  page: 0,
  selectedSubSeller: null,
  searchTerm: "",
  hasNextPage: true,
  matchingResults: 0,
  subSellerProfile: {},
  backToSubseller: false,
};

const subSellerSlice = createSlice({
  name: "subSeller",
  initialState,
  reducers: {
    setInputMode: (state, action) => {
      state.isInput = false;
    },
    backToSubseller: (state, action) => {
      state.backToSubseller = action.payload
    },
    resetAll: (state, action) => {
      state.page = 0;
      state.searchedSubSellers = [];
      state.selectedSubSeller = null;
      state.selectedStatus = 0;
    },
    setPage: (state, action) => {
      state.page += 6;
    },
    setSearchedSubSellers: (state, action) => {
      let data = action.payload.data;
      if (action.payload?.searchTerm) {
        state.searchTerm = action.payload.searchTerm;
      }
      if (action.payload.change) {
        state.hasNextPage = data.length === 6;
        state.searchedSubSellers.push(...data);
      } else {
        if (action.payload.change !== null) {
          state.hasNextPage = data.length === 6;
          state.searchedSubSellers = data;
          state.page = 0;
        }
      }
      if (
        action.payload?.count !== undefined &&
        action.payload?.count !== null
      ) {
        state.matchingResults = action.payload.count;
      }
      state.loading = action.payload.loading;
      state.isInput = action.payload.isInput;
    },
    getSearchedSubSellers: (state, action) => {
      state.loading = true;
    },
    setSelectedSubSellerID: (state, action) => {
      state.selectedSubSellerID = action.payload.data;
    },
    setSelectedSubSeller: (state, action) => {

      state.selectedSubSeller = {
        ...action.payload.data.seller[0].pos_preference?.split(",").reduce(
          (int, val) => {
            val = val.split("-");
            if (val[1] === "supported") int.sup.push(val[0]);
            else int.notsup.push(val[0]);
            return int;
          },
          { sup: [], notsup: [] }
        ),
        ...action.payload.data.seller[0],
        contact: action.payload.data.contact,
      };
    },
    resetSearchTerm: (state, action) => {
      state.searchTerm = "";
    },
    getAllStatuses: () => {},
    getAllProfileStatuses: () => {},
    getAllRejectedReason: () => {},
    getProfileDetail: () => {},
    getAllGdsAggregator: () => {},
    approveSubseller: () => {},
    rejectSubseller: () => {},
    getCSVData: (state, action) => {},
    setAllStatuses: (state, action) => {
      state.statuses = action.payload;
    },
    setAllRejectedReasonSaga: (state, action) => {
      state.rejectReason = action.payload;
    },
    setAllProfileStatuses: (state, action) => {
      state.profileStatuses = action.payload;
    },
    setProfileDetail: (state, action) => {
      state.profileDetail = action.payload;
    },
    setAllGdsAggregator: (state, action) => {
      state.gdsAggregator = action.payload;
    },
    getSubSellerProfile: () => {},
    setSubSellerProfile: (state, action) => {
        state.subSellerProfile = action.payload;
    }
  },
});

export const {
  getAllStatuses,
  getAllProfileStatuses,
  getAllRejectedReason,
  approveSubseller,
  getProfileDetail,
  setAllStatuses,
  setAllProfileStatuses,
  setAllRejectedReasonSaga,
  setProfileDetail,
  setAllGdsAggregator,
  getAllGdsAggregator,
  getCSVData,
  setInputMode,
  resetAll,
  setPage,
  backToSubseller,
  // setCurrentStatus,
  setSearchedSubSellers,
  getSearchedSubSellers,
  setSelectedSubSellerID,
  setSelectedSubSeller,
  resetSearchTerm,
  getSubSellerProfile,
  setSubSellerProfile,
} = subSellerSlice.actions;
export default subSellerSlice.reducer;
